import { render } from "./PersonalCharacteristics.vue?vue&type=template&id=516aa136"
import script from "./PersonalCharacteristics.vue?vue&type=script&lang=js"
export * from "./PersonalCharacteristics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__